import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Who do you work with?",
    a: "African businesses of all sizes — from limited liability companies and early-stage startups to revenue-generating SMEs and Series-A ready businesses across 14 African countries.",
  },
  {
    q: "Do you guarantee funding?",
    a: "No serious consultant can. What we guarantee is documentation and applications that meet the international standards funders expect — historically, our clients see a 94% application success rate.",
  },
  {
    q: "How long does an engagement take?",
    a: "Most Starter engagements take 2–3 weeks. Growth packages run 3–4 weeks. Scale packages with multiple applications run 4–6 weeks.",
  },
  {
    q: "Do you take equity or success fees?",
    a: "Never. Our pricing is fixed per application — $1,000, $1,500 or $3,000 depending on the package. No equity, no kickers.",
  },
  {
    q: "Which grants and funders do you target?",
    a: "Tony Elumelu Foundation, Mastercard Foundation, World Bank, USAID, EU/AfDB programs, IFC, FATE, and a growing list of pan-African and global VCs.",
  },
  {
    q: "What happens after we submit?",
    a: "We don't disappear. We support investor Q&A, follow-ups, and any clarifications the funder requests until a decision is made.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-6 sm:px-12">
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta">FAQ</p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-umber sm:text-5xl">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 divide-y divide-border">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-0">
              <AccordionTrigger className="py-5 text-left font-display text-lg font-medium text-umber hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-umber/70 text-base leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
